import { render, staticRenderFns } from "./RNASeqSetup.vue?vue&type=template&id=468ae5ea"
import script from "./RNASeqSetup.vue?vue&type=script&lang=ts"
export * from "./RNASeqSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports